export enum DeviceType {
	NotSet = "not-set",
	FrontScreen = "front",
	FrontPassenger = "front-passenger",
	RearLeft = "rear-left",
	RearRight = "rear-right",
	Companion = "companion",
}
